/**
 * SVG icon rendering for budget categories on Web.
 * Delegates to shared CategoryIconPaths for path data and
 * CategoryUtils.getCategoryIconId() for category-to-icon mapping.
 */
object CategoryIconSvg {

    /**
     * Render an inline SVG icon by icon ID.
     */
    fun render(iconId: String, size: Int = 20, color: String = "#ffffff"): String {
        val paths = utils.CategoryIconPaths.getSvgContent(iconId)
        // vertical-align:middle so the icon sits correctly when rendered inline
        // beside text (goal links / recommendations) as well as inside flexboxes.
        return """<svg xmlns="http://www.w3.org/2000/svg" width="$size" height="$size" viewBox="0 0 24 24" fill="none" stroke="$color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:middle;">$paths</svg>"""
    }

    /**
     * Render an inline SVG icon for a transaction category.
     */
    fun renderForCategory(category: String, merchant: String = "", size: Int = 20, color: String = "#ffffff"): String {
        val iconId = utils.CategoryUtils.getCategoryIconId(category, merchant)
        return render(iconId, size, color)
    }

    /**
     * Render a goal's iconEmoji field: SVG when it resolves to a CategoryIconPaths id,
     * otherwise the raw emoji wrapped in a span. Used inline in transaction rows so the
     * literal id (e.g. "tax") never leaks through as text.
     */
    fun renderGoalIcon(iconValue: String, size: Int = 14, color: String = "#66A3FF"): String {
        val resolvedId = utils.CategoryIconPaths.resolveIconId(iconValue)
        return if (resolvedId != null) {
            render(resolvedId, size, color)
        } else {
            """<span style="font-size: ${size}px;">$iconValue</span>"""
        }
    }
}
